import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSettlementTypes } from "../api/settlementTypes";

function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export function BaixaModal({
  show,
  title,
  confirmLabel,
  onClose,
  onConfirm,
  loading,
}: {
  show: boolean;
  title: string;
  confirmLabel: string;
  onClose: () => void;
  onConfirm: (input: { settlementTypeId: number; paidAt: string }) => void;
  loading?: boolean;
}) {
  const { data: settlementTypes } = useSettlementTypes();
  const [settlementTypeId, setSettlementTypeId] = useState<string>("");
  const [paidAt, setPaidAt] = useState(today());
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (show) {
      setSettlementTypeId("");
      setPaidAt(today());
      setError(null);
    }
  }, [show]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!settlementTypeId) return setError("Selecione o tipo de baixa.");
    if (!paidAt) return setError("Informe a data da baixa.");
    onConfirm({ settlementTypeId: Number(settlementTypeId), paidAt });
  }

  return (
    <Modal backdrop="static" keyboard={false} show={show} onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: 700 }}>
              Data da baixa
            </label>
            <input type="date" className="form-control" value={paidAt} onChange={(e) => setPaidAt(e.target.value)} />
          </div>
          <div>
            <label className="form-label" style={{ fontSize: "0.9rem", fontWeight: 700 }}>
              Tipo de baixa
            </label>
            <select className="form-select" value={settlementTypeId} onChange={(e) => setSettlementTypeId(e.target.value)}>
              <option value="">Selecione…</option>
              {settlementTypes?.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
            {settlementTypes && settlementTypes.length === 0 && (
              <div className="text-secondary mt-1" style={{ fontSize: 12 }}>
                Nenhum tipo de baixa cadastrado ainda — cadastre em Cadastros → Tipos de baixa.
              </div>
            )}
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={loading}>
            {confirmLabel}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
